import { compareAsc, endOfMonth, startOfMonth } from "date-fns";

import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { Parcel } from "@/features/modules/parcel/objects/Parcel";
import { parcelModel } from "@/features/modules/parcel/models/ParcelModel";
import { ParcelWithAction } from "../objects/ParcelWithAction";
import { ParcelActionType } from "@/features/modules/parcel/objects/ParcelActionType";
import { ParcelState } from "@/features/modules/parcel/objects/ParcelState";

export class HandleReportModel {
  public async calcHandleReport(companyId: string, monthDate: Date): Promise<ParcelWithAction[]> {
    try {
      if (companyId === undefined) throw new Error("companyIdUndefined");
      if (monthDate == undefined) throw new Error("monthDateUndefined");

      const startDate: Date = startOfMonth(monthDate);
      const endDate: Date = endOfMonth(monthDate);

      const parcels: Parcel[] = await parcelModel.getParcelsByCompanyAndPeriod(companyId, startDate, endDate);

      const results: ParcelWithAction[] = [];

      // initial count
      let initialCount = 0;
      for (const parcel of parcels) {
        let isStored = false;
        for (const action of parcel.actions) {
          action.date.setHours(23, 59, 59, 999);
          if (compareAsc(action.date, startDate) > 0) continue;

          if (!isStored) {
            if (action.action == ParcelActionType.Created) isStored = true;
          } else {
            if ([ParcelActionType.Sent, ParcelActionType.Deleted].includes(action.action)) isStored = false;
          }
        }
        if (isStored) initialCount++;
      }

      for (const parcel of parcels) {
        if (parcel.state === ParcelState.Deleted) continue;

        for (const parcelAction of parcel.actions) {
          const actionStart: Date = new Date(parcelAction.date.getTime());
          actionStart.setHours(0, 0, 0, 0);
          const actionEnd: Date = new Date(parcelAction.date.getTime());
          actionEnd.setHours(23, 59, 59, 999);
  
          if (parcelAction.action == ParcelActionType.Created || parcelAction.action == ParcelActionType.Sent) {
            if (compareAsc(parcelAction.date, startDate) < 0 || compareAsc(parcelAction.date, endDate) > 0) continue;
            results.push({
              order: undefined,
              date: parcelAction.date,
              shipment: parcelAction.action === ParcelActionType.Created ? parcel.inboundShipment : parcel.outboundShipment,
              type: parcel.type,
              code: parcel.code,
              action: parcelAction.action === ParcelActionType.Created ? 1 : -1,
              companyCodes: parcel.items.map((item) => item.code).join(", "),
              count: undefined,
            });
          }
        }
      }

      results.sort((a, b) => compareAsc(a.date ?? new Date(), b.date ?? new Date()));

      let index = 1;
      for (const result of results) {
        result.order = index++;
        initialCount += result.action ?? 0;
        result.count = initialCount;
      }

      return results;
    } catch (error: unknown) {
      appFaultModel.catchAppError("HandleReportModel.calcHandleReport", { companyId, monthDate }, error);
      return [];
    }
  }
}

export const handleReportModel: HandleReportModel = new HandleReportModel();
